// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__mPIqP","slide-in-out":"styles_slide-in-out__n2SbR","fade-in-out":"styles_fade-in-out__plupw"};